<template>
   <div class="crud-wrapper">
      <crud :form-component="ClientForm" :grid-columns="gridColumns"
            :pageFilters="pageFilters" obj="client">
      </crud>
   </div>
</template>

<script>
    import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';
    import ClientForm from './ClientForm';

    export default PageClass.extend({
        name: 'clients',

        data () {
            return {
                ClientForm,

                gridColumns: [
                    {
                        dataField: 'name',
                        caption: 'Nome',
                        minWidth: 120
                    },
                    {
                        dataField: 'mobileNumber',
                        caption: 'Fone',
                        minWidth: 90,
                        cellTemplate: (element, info) => {
                            let p = String(info.data.mobileNumber || '').replace('+55', '');
                            let f = this.$util.applyMask(p, (p.length > 10) ? '(99) 9 9999-9999' : '(##) ####-####');
                            $(`<span>${f}</span>`).appendTo(element);
                        },
                    },
                    {
                        dataField: 'federalId',
                        caption: 'CPF',
                        minWidth: 70,
                        cellTemplate: (element, info) => {
                            let f = this.$util.applyMask(info.data.federalId, '999.999.999-99');
                            $(`<span>${f}</span>`).appendTo(element);
                        }
                    },
                    {
                        dataField: 'birth',
                        caption: 'Nascimento',
                        dataType: 'date',
                        format: 'dd/MM/yyyy',
                        width: 110
                    },
                    {
                        dataField: 'city',
                        caption: 'Cidade'
                    },
                    {
                        dataField: 'state',
                        caption: 'Estado',
                        width: 90
                    },
                    {
                        name: 'origin',
                        width: 60,
                        alignment: 'center',
                        cellTemplate: (element, info) => {
                            if (info.data.personType === 'A') {
                                $(`<i class='fas fa-mobile-alt btn-grid-command'></i>`)
                                    //.on('dxclick', data, this.fabCommand)
                                    .appendTo(element);
                            }
                        }
                    },
                    {
                        dataField: 'origin',
                        caption: 'Origem',
                        minWidth: 120,
                        customizeText: function (data) {
                            let text;
                            switch(data.value){
                                case 'fgtslp':
                                    text = 'FGTS';
                                    break;
                                default:
                                    text = 'Aplicativo';
                                    break;
                            }
                            return text;
                        },
                    }
                ]
            };
        },

        created () {
            if (!this.hasPageFilters) {
                this.createPageFilters([
                    {
                        field: 'exchangeStatusId',
                        value: null,
                        label: ''
                    },
                    {
                        field: 'hasDebit',
                        value: false,
                        label: ''
                    }
                ]);
            }
        }
    });

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Clients.vue